export default {
  transaction: {
    title: 'Transaksi',
    select: 'Pilih',
    all: 'Semua',
    loading: 'Memuatkan...',
    noMoreData: 'Tiada data lagi',
    mockSuccess: 'Simulasi Berjaya',
    mockFail: 'Simulasi Gagal',
    mockSuccessDone: 'Simulasi berjaya selesai',
    mockFailDone: 'Simulasi gagal selesai',
    mockFailed: 'Simulasi gagal',
    today: 'Hari ini',
    yesterday: 'Semalam',
    last3Days: '3 hari lepas',
    last7Days: '7 hari lepas',
    last15Days: '15 hari lepas',
    last30Days: '30 hari lepas',
    allTypes: 'Semua jenis',
    deposit: 'Deposit',
    withdrawal: 'Pengeluaran',
    withdrawalRefund: 'Bayaran balik pengeluaran',
    bet: 'Pertaruhan',
    win: 'Menang',
    manualAdd: 'Tambah manual',
    manualSubtract: 'Tolak manual',
    commission: 'Komisen',
    bonus: 'Bonus',
    vipUpgradeReward: 'Ganjaran naik taraf VIP',
    vipSalary: 'Gaji VIP',
    gameOutPrincipal: 'Keluar permainan - Pokok',
    gameOutBonus: 'Keluar permainan - Bonus',
    bonusTransferOut: 'Pindahan bonus keluar',
    allStats: 'Semua status',
    underReview: 'Dalam semakan',
    pendingPayout: 'Menunggu pembayaran',
    successful: 'Berjaya',
    failed: 'Gagal',
    cancelled: 'Dibatalkan',
    processing: 'Memproses',
  },
};
